import {
    combineReducers,
    createStore,
    applyMiddleware,
} from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

import {
    allEmergenciesReducer,
    newEmergenciesReducer,
    filteredEmergenciesReducer,
    allFiltersReducer,
    selectedEmergencyReducer,
    mapReducer
} from '../reducers';

const allReducers = combineReducers({
    allEmergencies: allEmergenciesReducer,
    newEmergencies: newEmergenciesReducer,
    filteredEmergencies: filteredEmergenciesReducer,
    selectedEmergency: selectedEmergencyReducer,
    filters: allFiltersReducer,
    mapData: mapReducer
});

const store = createStore(
    allReducers,
    composeWithDevTools(applyMiddleware(thunk))
);

export const STORE = (state) => state;

export default store;
